import styled from 'styled-components';
import { shadows } from '../../utils/styled-component-mixins';

const NoResultsCardStyled = styled.div`
  display: flex;
  justify-content: center;

  .no-results-card {
    ${shadows.cardShadow};
    align-items: center;
    background-color: var(--white);
    display: flex;
    justify-content: center;
    min-height: 55.2rem;
    padding: 3.2rem;
    width: 31.5rem;
  }
`;

const NoResultsCard = (props) => {
  const { noResultsMessage, dangerouslySetInnerHTML = false } = props;

  return (
    <NoResultsCardStyled className="no-results-wrapper">
      <div className="no-results-card">
        {dangerouslySetInnerHTML ? (
          <div dangerouslySetInnerHTML={{ __html: noResultsMessage }} />
        ) : (
          <p>{props.noResultsMessage}</p>
        )}
      </div>
    </NoResultsCardStyled>
  );
};

export default NoResultsCard;
